import type * as lazyIndex from "./lazyIndex";
import { LazyModule, LazyAction } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "CopilotInbox"*/ "./lazyIndex"), { name: "CopilotInbox" });

export const lazyCopilotInboxProcessorForSelectedRows: LazyAction<typeof lazyIndex.copilotInboxProcessorForSelectedRows, typeof lazyModule> = new LazyAction(lazyModule, m => m.copilotInboxProcessorForSelectedRows);

export const lazyFetchCopilotInboxHeadline: LazyAction<typeof lazyIndex.fetchCopilotInboxHeadline, typeof lazyModule> = new LazyAction(lazyModule, m => m.fetchCopilotInboxHeadline);

export const lazyProcessFolderForPrioritization: LazyAction<typeof lazyIndex.processFolderForPrioritization, typeof lazyModule> = new LazyAction(lazyModule, m => m.processFolderForPrioritization);

// Export types
export type { PrioritizationResult } from "./services/inboxPrioritizationCategoryService";
